import * as React from 'react';

import {
  IBusinessShoppingCenterSchema,
  IOfferSchema,
  IAgentSchema,
  IKPSchema,
  ECoworkingOfferType,
} from '@cian/api-models/offer-card/v1/get-offer-data';
import { getCommercialBuildingClass, getOfferTitle, getSquareInformation } from '../../utils/offer_helpers';
import { getOfferType, isCommercial } from '../../utils/offer_type';
import * as styles from './index.css';
import { Link } from '../../common/components/link';
import { trackKPLinkClick } from '../../utils/countrySideCardIntegrationTracking';

export interface IOfferTitleProps {
  businessShoppingCenter: IBusinessShoppingCenterSchema | null;
  offer: IOfferSchema;
  isCountrysideCardIntegrated: boolean;
  agent: IAgentSchema | null;
  kp: IKPSchema | null;
}

export class OfferTitle extends React.PureComponent<IOfferTitleProps, {}> {
  public render() {
    const { isCountrysideCardIntegrated, kp } = this.props;

    return (
      <h1 className={styles['title']}>
        {this.getTitle()}
        {isCountrysideCardIntegrated && kp && <> в посёлке {this.renderIntegratedKpLink(kp)}</>}
      </h1>
    );
  }

  private handleClick = () => {
    const { offer, agent, kp } = this.props;
    trackKPLinkClick('card_name_kp_in_newlist', offer, agent, kp && kp.id);
  };

  private getTitle = (): string => {
    const { businessShoppingCenter, offer } = this.props;

    const offerType = getOfferType(offer);
    const commercialBuildingClass = getCommercialBuildingClass(offer.building, businessShoppingCenter);
    let title = getOfferTitle(offer);
    const squareInformation = getSquareInformation(offer);

    if (!!offer.coworkingOfferType) {
      return this.getFormattedCoworkingTitle(title, squareInformation);
    }

    if (isCommercial(offerType) && commercialBuildingClass) {
      title += ` ${commercialBuildingClass}`;
    }

    if (squareInformation) {
      title += `, ${squareInformation}`;
    }

    return title;
  };

  private getFormattedCoworkingTitle = (title: string, squareInformation: string): string => {
    const { workplaceCount, coworkingOfferType } = this.props.offer;

    if (coworkingOfferType === ECoworkingOfferType.Office) {
      const workplaces = workplaceCount ? `на ${workplaceCount} чел.` : '';

      return [title, squareInformation, workplaces].filter(Boolean).join(' ');
    }

    return title;
  };

  private renderIntegratedKpLink = (kp: IKPSchema) => (
    <>
      {kp.url ? (
        <Link className={styles['link']} href={kp.url} target="_blank" rel="noopener" onClick={this.handleClick}>
          «{kp.name}»
        </Link>
      ) : (
        <span>«{kp.name}»</span>
      )}
    </>
  );
}
